import { render, staticRenderFns } from "./UserContentMailHistory.vue?vue&type=template&id=75bf6690&"
import script from "./UserContentMailHistory.vue?vue&type=script&lang=ts&"
export * from "./UserContentMailHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports